// Nasıl oynanır? — "how_to_play_dialogs" tasarımındaki altın çerçeveli tek
// sayfalık dialog. Üstte EŞLİ / TEKLİ / GÖMMELİ sekme görselleri; seçili olan
// büyütülüp parlatılır (tasarım gereği), içerik seçilen moda göre değişir.
// İlk açılışta otomatik gösterilir (localStorage batak_tutorial_seen);
// kapatınca bir daha otomatik çıkmaz. Bileşen başlatıcı butonu da kendisi çizer.
import { useState, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import imgHowTo from '../../assets/btn_nasil_oynanir.png';
import imgFrame from '../../assets/tut_dialog_frame.png';
import imgTabEsli from '../../assets/tut_tab_esli.png';
import imgTabTekli from '../../assets/tut_tab_tekli.png';
import imgTabGommeli from '../../assets/tut_tab_gommeli.png';
import imgOynanis from '../../assets/tut_oynanis_title.png';
import imgDivider from '../../assets/tut_divider.png';
import imgBullet from '../../assets/tut_bullet.png';

const SEEN_KEY = 'batak_tutorial_seen';

const seen = () => {
    try { return localStorage.getItem(SEEN_KEY) === '1'; } catch (e) { return true; }
};
const markSeen = () => {
    try { localStorage.setItem(SEEN_KEY, '1'); } catch (e) {}
};

// Lobide seçili mod hangisiyse dialog o sekmeyle açılsın
const initialTab = () => {
    try {
        return { partner: 'esli', solo: 'tekli', gomme: 'gommeli' }[localStorage.getItem('batak_mode')] || 'esli';
    } catch (e) { return 'esli'; }
};

// Metinler tasarımdaki (dialog_olmasi_gereken_ve_yazilar.png) yazıların birebiri
const MODES = [
    {
        id: 'esli',
        img: imgTabEsli,
        alt: 'Eşli',
        sections: [
            {
                h: 'İhale ve Koz',
                p: ['Oyuncular sırayla kaç el alabileceklerini söyler. En yüksek teklifi veren oyuncu ihaleyi kazanır ve oyunun kozunu belirler. Koz, diğer kartlardan daha güçlü olan renktir.'],
            },
            {
                h: 'Kartları Oyna',
                p: [
                    'İlk oyuncu bir kart atar. Diğer oyuncular, ellerinde varsa aynı renkten kart atmak zorundadır. Elinde o renkten kart yoksa başka bir kart veya koz oynayabilirsin.',
                    'Aynı renkte oynanan kartlar arasında en yüksek kart eli kazanır. Koz oynanmışsa en yüksek koz kartı eli alır.',
                ],
            },
            {
                h: 'Takımınla Kazan',
                p: ['Sen ve eşinin aldığı eller takımınız için birlikte hesaplanır. İhaleyi alan takım, söylediği el sayısına ulaşmaya çalışır. Sözü tutarsanız puan kazanırsınız, tutamazsanız puan kaybedersiniz.'],
            },
        ],
        tip: 'Eşinin oynadığı kartları takip et, yüksek kartlarını doğru zamanda kullan ve kozlarını gereksiz yere harcama!',
    },
    {
        id: 'tekli',
        img: imgTabTekli,
        alt: 'Tekli',
        sections: [
            { h: 'Dağıtım', p: ['52 kart oyunculara dağıtılır. Her oyuncunun elinde 13 kart bulunur.'] },
            { h: 'İhale', p: ['Oyuncular sırayla kaç el alabileceklerini söyler. En yüksek teklifi veren oyuncu ihaleyi kazanır ve koz rengini belirler.'] },
            { h: 'El Oynama', p: ['İlk oyuncu bir kart açar. Diğer oyuncular ellerinde varsa aynı renkten kart atmalıdır. O renkten kartı olmayan oyuncu, elinde varsa koz oynar; kozu da yoksa istediği kartı atabilir.'] },
            { h: 'Eli Kazanma', p: ['Koz oynandıysa en yüksek koz, koz oynanmadıysa açılan renkteki en yüksek kart eli kazanır. Eli kazanan oyuncu sonraki eli başlatır.'] },
            { h: 'Oyun Sonu', p: ['İhaleyi alan oyuncu, söylediği kadar veya daha fazla el alırsa başarılı olur. Hedefine ulaşamazsa puan kaybeder. Oyun sonunda en yüksek puana ulaşan oyuncu kazanır.'] },
        ],
        tip: 'Kozlarını doğru zamanda kullan, çıkan kartları takip et ve ihalede alabileceğinden fazla el söyleme.',
    },
    {
        id: 'gommeli',
        img: imgTabGommeli,
        alt: 'Gömmeli',
        sections: [
            { h: 'Dağıtım', p: ["52 kartın 48'i oyunculara dağıtılır. Her oyuncuya 16 kart verilir, kalan 4 kart kapalı olarak masaya bırakılır. Bu kartlara gömü denir."] },
            { h: 'İhale', p: ['Oyuncular sırayla kaç el alabileceklerini söyler. En yüksek teklifi veren oyuncu ihaleyi kazanır.'] },
            { h: 'Gömüyü Alma', p: ['İhaleyi kazanan oyuncu masadaki 4 kapalı kartı eline alır. Ardından elinden istemediği 4 kartı tekrar kapalı şekilde gömer ve koz rengini belirler.'] },
            { h: 'El Oynama', p: ['İlk oyuncu bir kart açar. Diğer oyuncular ellerinde varsa aynı renkten kart atmak zorundadır. O renkten kartı olmayan oyuncu, kurala uygunsa koz kullanır.'] },
            { h: 'Eli Kazanma', p: ['Koz oynandıysa en yüksek koz, koz yoksa açılan renkteki en yüksek kart eli kazanır. Eli alan oyuncu bir sonraki eli başlatır.'] },
            { h: 'Oyun Sonu', p: ['İhaleyi alan oyuncu söylediği el sayısına ulaşmaya çalışır. Hedefini tutturursa puan kazanır, tutturamazsa puan kaybeder.'] },
        ],
        tip: 'Gömüden gelen kartları değerlendirirken elindeki güçlü renkleri koru ve kozlarını mümkün olduğunca kontrollü kullan.',
    },
];

const CSS = `
#batakTut{position:fixed;inset:0;z-index:10005;display:flex;align-items:center;justify-content:center;background:rgba(2,8,5,.88);font-family:inherit;padding:12px}
#batakTut .tutPanel{position:relative;width:min(92vw,390px);height:min(78vh,640px);background:url(${imgFrame}) center / 100% 100% no-repeat;box-sizing:border-box;padding:7% 8.5% 7%;display:flex;flex-direction:column;color:#fff}
#batakTut .tutClose{position:absolute;top:4px;right:4px;width:40px;height:40px;padding:0;border-radius:50%;border:2px solid #e9c25f;background:radial-gradient(circle at 35% 30%,#1d5232,#0b2917 72%);color:#f3d47a;font-size:20px;font-weight:700;line-height:36px;text-align:center;cursor:pointer;box-shadow:0 2px 8px rgba(0,0,0,.6),inset 0 1px 2px rgba(255,255,255,.18);-webkit-tap-highlight-color:transparent;z-index:3}
#batakTut .tutClose:active{transform:scale(.92)}
#batakTut .tutTitle{display:flex;align-items:center;justify-content:center;gap:9px;margin-top:4%}
#batakTut .tutTitle .txt{font-family:Georgia,'Times New Roman',serif;font-weight:700;font-size:clamp(19px,6vw,23px);letter-spacing:.4px;white-space:nowrap;background:linear-gradient(180deg,#ffeeb0,#f3c85b 48%,#c9922e);-webkit-background-clip:text;background-clip:text;color:transparent;-webkit-text-fill-color:transparent;filter:drop-shadow(0 1.5px 1px rgba(0,0,0,.55))}
#batakTut .tutTitle .orn{flex:0 0 22px;height:2px;background:linear-gradient(90deg,transparent,#dcae52);position:relative}
#batakTut .tutTitle .orn.r{background:linear-gradient(270deg,transparent,#dcae52)}
#batakTut .tutTitle .orn::after{content:'';position:absolute;top:50%;width:7px;height:7px;background:#e9c25f;transform:translateY(-50%) rotate(45deg);box-shadow:0 0 4px rgba(233,194,95,.7)}
#batakTut .tutTitle .orn.l::after{right:-2px}
#batakTut .tutTitle .orn.r::after{left:-2px}
#batakTut .tutTabs{display:flex;align-items:center;justify-content:center;gap:4.5%;margin:5% 0 1.5%}
#batakTut .tutTab{flex:0 0 27%;padding:0;border:none;background:none;cursor:pointer;transition:transform .18s ease;-webkit-tap-highlight-color:transparent}
#batakTut .tutTab img{display:block;width:100%;height:auto;filter:brightness(.68) saturate(.8);transition:filter .18s ease}
#batakTut .tutTab.on{transform:scale(1.22);position:relative;z-index:2}
#batakTut .tutTab.on img{filter:drop-shadow(0 0 9px rgba(240,196,80,.4))}
#batakTut .tutBody{flex:1;min-height:0;overflow-y:auto;margin-top:3.5%;padding:1% 1.5% 7%;-webkit-overflow-scrolling:touch;scrollbar-width:none}
#batakTut .tutBody::-webkit-scrollbar{display:none}
#batakTut .tutSection{display:block;width:60%;max-width:230px;margin:1% 0 4.5%}
#batakTut .tutItem{display:flex;align-items:flex-start;gap:8px;margin-bottom:11px;text-align:left}
#batakTut .tutItem .bul{flex:0 0 12px;width:12px;height:12px;margin-top:3px}
#batakTut .tutItem b{display:block;font-size:13.5px;font-weight:700;color:#fff;margin-bottom:3px}
#batakTut .tutItem p{margin:0 0 6px;font-size:12.5px;line-height:1.5;color:rgba(234,243,236,.85)}
#batakTut .tutItem p:last-child{margin-bottom:0}
#batakTut .tutDivider{display:block;width:70%;margin:5.5% auto 5%}
#batakTut .tutTip{text-align:left}
#batakTut .tutTip b{display:block;font-size:13.5px;font-weight:700;color:#fff;margin-bottom:3px}
#batakTut .tutTip p{margin:0;font-size:12.5px;line-height:1.5;color:rgba(234,243,236,.85)}
.batakHowTo{display:block;margin:0 auto;width:min(216px,60vw);padding:0;border:none;background:none;cursor:pointer;-webkit-tap-highlight-color:transparent}
.batakHowTo img{display:block;width:100%;height:auto}
.batakHowTo:active{transform:scale(.96)}
`;

// Lobide masaların altına konur: başlatıcı butonu + dialog tek bileşende.
const BatakTutorial = () => {
    const [open, setOpen] = useState(false);
    const [tab, setTab] = useState('esli');
    const bodyRef = useRef(null);

    // İlk kez oynayanlara otomatik göster (oturum başına bir kez)
    useEffect(() => {
        if (window.__batakTutAutoShown || seen()) return;
        window.__batakTutAutoShown = true;
        setTab(initialTab());
        setOpen(true);
    }, []);

    const openTut = () => { setTab(initialTab()); setOpen(true); };
    const close = () => { markSeen(); setOpen(false); };
    const switchTab = (id) => {
        setTab(id);
        if (bodyRef.current) bodyRef.current.scrollTop = 0;
    };

    const mode = MODES.find((m) => m.id === tab) || MODES[0];
    return (
        <>
            <style>{CSS}</style>
            <button type="button" className="batakHowTo" onClick={openTut}>
                <img src={imgHowTo} alt="Nasıl oynanır?" draggable={false} />
            </button>
            {open && createPortal(
                <div id="batakTut" onClick={close}>
                    <div className="tutPanel" onClick={(e) => e.stopPropagation()}>
                        <button type="button" className="tutClose" onClick={close} aria-label="Kapat">✕</button>
                        <div className="tutTitle">
                            <span className="orn l" />
                            <span className="txt">NASIL OYNANIR?</span>
                            <span className="orn r" />
                        </div>
                        <div className="tutTabs">
                            {MODES.map((m) => (
                                <button
                                    key={m.id}
                                    type="button"
                                    className={`tutTab${tab === m.id ? ' on' : ''}`}
                                    onClick={() => switchTab(m.id)}
                                >
                                    <img src={m.img} alt={m.alt} draggable={false} />
                                </button>
                            ))}
                        </div>
                        <div className="tutBody" ref={bodyRef}>
                            <img className="tutSection" src={imgOynanis} alt="Oyunun Oynanışı" draggable={false} />
                            {mode.sections.map((s) => (
                                <div className="tutItem" key={s.h}>
                                    <img className="bul" src={imgBullet} alt="" draggable={false} />
                                    <div>
                                        <b>{s.h}</b>
                                        {s.p.map((t, i) => <p key={i}>{t}</p>)}
                                    </div>
                                </div>
                            ))}
                            <img className="tutDivider" src={imgDivider} alt="" draggable={false} />
                            <div className="tutTip">
                                <b>İpucu</b>
                                <p>{mode.tip}</p>
                            </div>
                        </div>
                    </div>
                </div>,
                document.body
            )}
        </>
    );
};

export default BatakTutorial;
